/** Tier-based feature gating hook. */

import { useAuth } from "@/hooks/useAuth";

const TIER_LEVEL: Record<string, number> = {
  user: 0,
  power_user: 1,
  admin: 2,
};

export function useFeatureGate(requiredTier: "user" | "power_user" | "admin") {
  const { tier } = useAuth();
  return {
    hasAccess: (TIER_LEVEL[tier] ?? 0) >= (TIER_LEVEL[requiredTier] ?? 0),
    tier,
  };
}
